import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b79ac2a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2b79ac2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79ac2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewCard: require('/home/circleci/repo/components/ReviewCard.vue').default})
